import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  // First merge with tailwind-merge for Tailwind class conflicts
  const merged = twMerge(clsx(inputs))

  // Then deduplicate exact string matches
  const classes = merged.split(' ').filter(Boolean)
  const unique = Array.from(new Set(classes))

  return unique.join(' ')
}
